// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TChangeStatusRequest,
  TChangeStatusModel,
  IMappers,
  TChangeStatusResponse,
  TChangeStatusResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createChangeStatusModel(parameters: TChangeStatusRequest): TChangeStatusModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'cian-dobro',
    pathApi: '/v1/change-status/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IChangeStatusOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TChangeStatusRequest;
}

export async function fetchChangeStatus<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IChangeStatusOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TChangeStatusResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createChangeStatusModel(parameters),
    config,
  )) as FetchResponse<TChangeStatusResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TChangeStatusResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TChangeStatusResponse>;
}
